module.exports = __webpack_public_path__ + "static/Unisel1-6a936ec94f554670863c6428400e84be.jpg";